/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("ArrayInDataClass")
package features.orderStatus.models

import kangaroorewards.appsdk.core.io.Model
import kotlin.js.ExperimentalJsExport
import kotlin.js.JsExport
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable


@ExperimentalJsExport
@JsExport
@Serializable
data class OrderStatusModel(
    @SerialName("id")
    val id: Int?,

    @SerialName("type_id")
    val typeId: Int?,

    @SerialName("type")
    val type: String?,

    @SerialName("description")
    val description: String?,

    @SerialName("points")
    val points: Int?,

    @SerialName("amount")
    val amount: Double?,

    @SerialName("hidden")
    val hidden: Boolean?,

    @SerialName("created_at")
    val createdAt: String?,

    @SerialName("archived")
    val archived: Boolean?
) : Model()
